<app-generic-form [title]="title" [wide]="true">
  <form [formGroup]="eventForm" (ngSubmit)="onSubmit()" [id]="formId" class="row g-3" form-content>
    <div class="col-12">
      <label class="form-label" for="organizationId">Organizzazione</label>
      <select id="organizationId" class="form-select" formControlName="organizationId" required>
        <option [ngValue]="null" disabled>Seleziona un'organizzazione</option>
        @for (organization of availableOrganizations; track organization.id) {
          <option [ngValue]="organization.id">{{ organization.organizationName }}</option>
        }
      </select>
    </div>

    <div class="col-12">
      <label class="form-label" for="name">Titolo</label>
      <input id="name" type="text" class="form-control" formControlName="name" required>
    </div>

    <div class="col-12">
      <label class="form-label" for="description">Descrizione</label>
      <quill-editor
        id="description"
        class="description-editor"
        formControlName="description"
        [modules]="quillModules"
        format="html"
        placeholder="Scrivi la descrizione dell'evento...">
      </quill-editor>
    </div>

    <div class="col-12">
      <label class="form-label" for="imageUrl">Immagine (URL)</label>
      <input id="imageUrl" type="url" class="form-control" formControlName="imageUrl" placeholder="https://...">
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label" for="startDate">Data inizio <span class="text-danger">*</span></label>
      <input id="startDate" type="date" class="form-control" formControlName="startDate" required>
      @if (eventForm.get('startDate')?.touched && eventForm.get('startDate')?.invalid) {
        @if (eventForm.get('startDate')?.hasError('required')) {
          <small class="text-danger">La data di inizio è obbligatoria.</small>
        }
        @if (eventForm.get('startDate')?.hasError('pastDate')) {
          <small class="text-danger">La data di inizio non può essere nel passato.</small>
        }
      }
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label" for="endDate">Data fine <span class="text-muted">(default uguale a data inizio)</span></label>
      <input id="endDate" type="date" class="form-control" formControlName="endDate">
      @if (eventForm.get('endDate')?.touched && eventForm.get('endDate')?.invalid) {
        @if (eventForm.get('endDate')?.hasError('pastDate')) {
          <small class="text-danger">La data di fine non può essere nel passato.</small>
        }
      }
    </div>

    @if (eventForm.errors?.['endBeforeStart'] && eventForm.get('endDate')?.touched) {
      <div class="col-12">
        <small class="text-danger">La data di fine non può essere precedente alla data di inizio.</small>
      </div>
    }

    <div class="col-12">
      <app-location-form [parentForm]="eventForm"></app-location-form>
    </div>
  </form>

  <div class="d-flex justify-content-end gap-2" form-actions>
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
      <i class="bi bi-x-lg me-1" aria-hidden="true"></i>Annulla
    </button>
    <button type="submit" class="btn btn-primary" [attr.form]="formId" [disabled]="!eventForm.valid">
      <i class="bi bi-check-lg me-1" aria-hidden="true"></i>{{ submitLabel }}
    </button>
  </div>
</app-generic-form>
